import React, { memo } from 'react';
import { IoConstructOutline, IoPowerOutline } from 'react-icons/io5';
import { signOut } from 'next-auth/react';

import { NextImage, SmartLink } from '@/app/_components';
import { ROUTERS } from '@/constant';
import { useLang } from '@/hooks';
import { useChangeLocale } from '@/locales/client';
import { ExclamationCircleFilled } from '@ant-design/icons';

import { useAuthStore } from '../LoginModal/Auth.store';
import {
	ADMIN,
	EXPERT,
	HEADERS_MOBILE,
	MODERATOR,
	TRANSLATE,
} from './header.constant';

import { Modal } from 'antd';
import { includes } from 'ramda';

const { confirm } = Modal;
const HeaderMobile: React.FC<{
	isMenu: boolean;
	setMenu: (status: boolean) => void;
	pathname: string;
}> = ({ isMenu, setMenu, pathname }) => {
	const changeLocale = useChangeLocale();
	const { t, lang } = useLang();
	const { setShowAuthModal, profile, logout } = useAuthStore(
		(state) => state
	);

	const handleLogout = () => {
		confirm({
			title: `${t('header.confirm')}`,
			icon: <ExclamationCircleFilled />,
			okText: t('header.yes'),
			okType: 'danger',
			cancelText: t('header.no'),
			onOk() {
				signOut();
				logout();
			},
		});
	};

	const handleTranslate = (item: any) => {
		if (item?.id === 1) changeLocale();
		else changeLocale();
	};

	// Go to admin page
	const checkRoles = includes(profile?.roles?.[0], [
		ADMIN,
		EXPERT,
		MODERATOR,
	]);
	const showLoginInCourse = includes(pathname, [
		ROUTERS.COURSE,
		ROUTERS.COURSE_DETAIL,
		ROUTERS.LESSON_DETAIL,
	]);

	return (
		<>
			<div
				aria-hidden={'true'}
				className={`lg:hidden fixed top-12 right-0 w-[260px] bottom-0 bg-white z-50 transition-all duration-100 box-shadow ${
					isMenu ? 'opacity-100 translate-x-0 ' : 'translate-x-full'
				}`}
			>
				<div className={'max-md:mt-4 max-lg:mt-10'}>
					{profile && pathname === '/course' && (
						<div className={'px-6 mb-2 text-center'}>
							<p className={'text-gray text-sm'}>
								{t('header.hello')}
							</p>
							<p className={'truncate text-sm font-bold'}>
								{profile.firstName + ' ' + profile.lastName}
							</p>
						</div>
					)}
					<div className={'row justify-center px-6 space-x-4 mb-3'}>
						{TRANSLATE.map((item) => (
							<button
								key={item?.id.toString()}
								className={`w-[30px] drop-shadow ${
									lang === item?.label
										? 'border-[2px] border-blue-7'
										: 'border-[2px] border-white'
								}`}
								onClick={() => handleTranslate(item)}
							>
								<NextImage
									src={item?.url}
									placeholder="blur"
									className="object-cover bg-center bg-cover"
									priority
								/>
							</button>
						))}
					</div>
					<div className={'h-px bg-blue-7/20'} />
					{HEADERS_MOBILE.map((item, index) => (
						<div key={index} className={'pt-2 overflow-hidden'}>
							<SmartLink href={item?.route}>
								<p
									onClick={() => setMenu(false)}
									className={`px-6 py-2 uppercase hover:text-blue-9 `}
								>
									<span
										className={
											pathname === item?.route
												? 'border-b-[2px] border-blue-9'
												: ''
										}
									>
										{t(item.label)}
									</span>
								</p>
							</SmartLink>
						</div>
					))}
					<SmartLink href={ROUTERS.CONTACT}>
						<p
							onClick={() => setMenu(false)}
							className={`px-6 py-2 uppercase hover:text-blue-9 `}
						>
							<span
								className={
									pathname === 'contact'
										? 'border-b-[2px] border-blue-9'
										: ''
								}
							>
								{t('header.contact')}
							</span>
						</p>
					</SmartLink>
					{profile && showLoginInCourse && (
						<div className={'h-px bg-blue-7/20'} />
					)}
					{profile && showLoginInCourse && (
						<div className={'mt-4 px-6'}>
							{checkRoles && (
								<SmartLink
									href={
										profile?.roles?.[0] === EXPERT ||
										profile?.roles?.[0] === MODERATOR
											? ROUTERS.ADMIN_EXPERT_BLOG
											: ROUTERS.ADMIN_DASHBOARD
									}
								>
									<button
										className={
											'py-1.5 px-3 row justify-center space-x-3 border border-blue-9 hover:shadow-card bg-white rounded-full hover:bg-blue-9  hover:text-blue-9 w-full mb-4 duration-200'
										}
									>
										<IoConstructOutline />
										<span>{t('header.admin')}</span>
									</button>
								</SmartLink>
							)}
							<button
								onClick={handleLogout}
								className={
									'py-1.5 px-3 row justify-center bg-white rounded-full hover:bg-blue-9 space-x-3 border border-blue-9 hover:shadow-card hover:text-blue-9 w-full duration-200'
								}
							>
								<IoPowerOutline />
								<span>{t('header.logout')}</span>
							</button>
						</div>
					)}
					`
					{profile ? null : (
						<div className={'mt-4 px-6'}>
							<button
								onClick={() => setShowAuthModal(true)}
								className={
									'border border-blue-9 bg-white text-sm py-2 px-3 rounded-full hover:bg-blue-9 hover:text-white hover:shadow-card duration-200 w-full'
								}
							>
								{t('header.sign-in')}
							</button>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default memo(HeaderMobile);
